// start:ng42.barrel
import   './user-form-bulk-view.component';
import   './user-form-capture.component';
import   './user-form-tab-capture.component';
// end:ng42.barrel

